/* Small display helpers shared by Team and an account's Access view. */

import { useTranslation } from 'react-i18next';
import { GROUPS, groupState, type Access } from './permissionModel';

export const initial = (s: string | null | undefined) => (s || '?').trim().charAt(0).toUpperCase() || '?';
export const nameOf = (p: { username?: string | null; email?: string | null; user_id: string }) => p.username || p.email || p.user_id;

/** One line of grants, as words: the groups that are on. */
export function useAccessSummary() {
  const { t } = useTranslation('agency');
  return (access: Access) => GROUPS.filter((g) => groupState(access, g) !== 'none').map((g) => t(g.labelKey)).join(' · ') || t('fleet.noAccess');
}
